import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["AdornmentLeft", "AdornmentRight"];
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
import CustomPropTypes from '../../util/custom-prop-types';
import { AdornmentMixin, AdornmentLeftMixin, AdornmentRightMixin } from '../../mixins/components/AdornmentMixin';
import { ADORNMENT_POSITIONS } from '../../constants/ADORNMENT';
export var StyledAdornment = /*#__PURE__*/styled('label').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['disabled', 'readOnly'])
}).withConfig({
  displayName: "StyledAdornment",
  componentId: "c11n-8-64-0__sc-1kerx9v-0"
})(["", ""], AdornmentMixin);
export var AdornmentLeft = /*#__PURE__*/styled(StyledAdornment).withConfig({
  displayName: "AdornmentLeft",
  componentId: "c11n-8-64-0__sc-1kerx9v-1"
})(["", ""], AdornmentLeftMixin);
export var AdornmentRight = /*#__PURE__*/styled(StyledAdornment).withConfig({
  displayName: "AdornmentRight",
  componentId: "c11n-8-64-0__sc-1kerx9v-2"
})(["", ""], AdornmentRightMixin);
export var StyledAdornmentLeft = AdornmentLeft;
export var StyledAdornmentRight = AdornmentRight;
/**
 * This is a generic adornment for [`AdornedInput`](#/Form%20components?id=adornedinput).
 * Children given to this component will be vertically centered and
 * text color will be adjusted.
 *
 * ##### Accessibility
 * Adornments are considered ornamental and set `aria-hidden="true"` by default.
 * If you believe your adornment is providing additional context without repeating content already
 * present in the form field label, consider setting `aria-hidden="false"`.
 *
 *     <Adornment aria-hidden="false">
 *
 * ##### Theming
 * * `StyledAdornment`
 * * `StyledAdornmentLeft`
 * * `StyledAdornmentRight`
 *
 * @since 6.4.0
 */

var Adornment = function Adornment(_ref) {
  var Left = _ref.AdornmentLeft,
      Right = _ref.AdornmentRight,
      props = _objectWithoutProperties(_ref, _excluded);

  return props.position === ADORNMENT_POSITIONS.left ? /*#__PURE__*/React.createElement(Left, _extends({
    "aria-hidden": "true"
  }, props)) : /*#__PURE__*/React.createElement(Right, _extends({
    "aria-hidden": "true"
  }, props));
};

Adornment.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The position of the adornment relative to the input. */
  position: PropTypes.oneOf(Object.keys(ADORNMENT_POSITIONS)),

  /**
   * `Adornment`s are only useful in the context of an `AdornedInput`
   * and must provide an `id` to link the label with the input.
   * **Note:** This is required, but it usually added directly by the
   * `AdornedInput`.
   */
  // Can't use `.isRequired` when dynamically added
  htmlFor: PropTypes.string,

  /** The default component for `position="left"` adornments. */
  AdornmentLeft: CustomPropTypes.extendsStyledComponent(AdornmentLeft),

  /** The default component for `position="right"` adornments. */
  AdornmentRight: CustomPropTypes.extendsStyledComponent(AdornmentRight)
} : {};
Adornment.defaultProps = {
  position: ADORNMENT_POSITIONS.left,
  AdornmentLeft: AdornmentLeft,
  AdornmentRight: AdornmentRight
};
export default Adornment;